import { render } from "./RegistrationSuccessful.vue?vue&type=template&id=11adb5bf"
import script from "./RegistrationSuccessful.vue?vue&type=script&lang=js"
export * from "./RegistrationSuccessful.vue?vue&type=script&lang=js"
script.render = render

export default script